import { Group, PageHeader, StatCard, Stack } from '@vipso/shared';
import { useGetOrgsQuery, useGetTenantsQuery } from '../api/adminApi';
import { useAdminAuth } from '../hooks/useAdminAuth';

export function HomePage() {
  const { admin } = useAdminAuth();
  const { data: tenantsData } = useGetTenantsQuery({ page: 1, pageLimit: 1 });
  const { data: activeOrgsData } = useGetOrgsQuery({ status: 'Active', page: 1, pageLimit: 1 });
  const { data: invitedOrgsData } = useGetOrgsQuery({ status: 'Invited', page: 1, pageLimit: 1 });

  const tenantCount = tenantsData?.tenants.total ?? 0;
  const activeOrgCount = activeOrgsData?.orgs.total ?? 0;
  const invitedOrgCount = invitedOrgsData?.orgs.total ?? 0;

  return (
    <Stack gap="lg">
      <PageHeader
        title="Dashboard"
        description={
          admin
            ? `Welcome back, ${admin.name}. Manage tenants, organizations, and platform staff.`
            : 'Manage tenants, organizations, and platform staff.'
        }
      />

      <Group grow align="stretch">
        <StatCard label="Tenants" value={String(tenantCount)} />
        <StatCard label="Active orgs" value={String(activeOrgCount)} />
        <StatCard label="Invited orgs" value={String(invitedOrgCount)} />
      </Group>
    </Stack>
  );
}
